import { Injectable, Injector } from '@angular/core';
import { Observable, of, map, tap } from 'rxjs';
import { Alert } from '../models/alert.model';
import { BaseApiService } from './baseapi.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService extends BaseApiService {
  alertMap!: Map<string, Alert[]>;

  constructor(protected injector: Injector) {
    super(injector);
  }

  fetchAlerts(pageType: string, campaignGuid?: string): Observable<Alert[]> {

    if (this.alertMap && this.alertMap.size > 0 && !this.alertMap.has(pageType)) {
      return of(this.alertMap.get(pageType));
    }

    const url = campaignGuid
    ? `${this.baseApiUrl}/content/campaign/${campaignGuid}/page/${pageType}/alerts`
    : `${this.baseApiUrl}/content/page/${pageType}/alerts`;

    return this.httpAuthGet(url).pipe(
      map((res) => res.data.map(( alert: any) => this.mapAlertItem(alert)),
      tap((alerts: Alert[]) => {
        this.alertMap.set(pageType, alerts);
      }))
    );
  }

  mapAlertItem(res: any): Alert {
    return {
      ...res,
      name: res.name,
      contentXML: res.contentXML,
      contentXML_fr: res.contentXML_fr,
    };
  }
}
